/* mkh-cart-drawer.js — Cart drawer for My Kitchen Gadgets */
(function(){
'use strict';
var GIFT_THRESHOLD=7500;
function fmt(c){return'$'+(c/100).toFixed(2);}
function el(id){return document.getElementById(id);}

function openDrawer(){
  el('mkh-cart-drawer').classList.add('is-open');
  el('mkh-drawer-overlay').classList.add('is-open');
  el('mkh-cart-drawer').setAttribute('aria-hidden','false');
  document.body.classList.add('mkh-drawer-open');
  loadCart();
}
function closeDrawer(){
  el('mkh-cart-drawer').classList.remove('is-open');
  el('mkh-drawer-overlay').classList.remove('is-open');
  el('mkh-cart-drawer').setAttribute('aria-hidden','true');
  document.body.classList.remove('mkh-drawer-open');
}
window.mkhOpenCart=openDrawer;
window.mkhCloseCart=closeDrawer;

function loadCart(){
  fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(c){renderDrawer(c);})
    .catch(function(){el('mkh-drawer-body').innerHTML='<p style="padding:24px;color:var(--ink-soft)">Could not load cart. <a href="/cart">View cart</a></p>';});
}

function renderDrawer(cart){
  // Count
  var countEl=el('mkh-drawer-count');
  countEl.textContent=cart.item_count>0?' ('+cart.item_count+')':'';
  // Progress
  var prog=el('mkh-ship-progress');
  if(cart.item_count>0){
    prog.style.display='';
    var remain=Math.max(0,GIFT_THRESHOLD-cart.total_price);
    var pct=Math.min(100,(cart.total_price/GIFT_THRESHOLD)*100);
    var msgEl=el('mkh-ship-msg');
    if(remain>0){
      msgEl.innerHTML='You\'re <b>'+fmt(remain)+'</b> away from a free gift &#127873;';
    } else {
      msgEl.innerHTML='<span style="color:var(--ok,#5a7d4e)">&#10003;</span> <b>You\'ve unlocked a free gift!</b>';
    }
    el('mkh-pbar-fill').style.width=pct+'%';
  } else {
    prog.style.display='none';
  }
  // Body
  var body=el('mkh-drawer-body');
  var foot=el('mkh-drawer-foot');
  if(cart.items.length===0){
    body.innerHTML='<div class="mkh-drawer-empty">'+
      '<div class="mkh-drawer-empty-icon"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>'+
      '<h3>Your cart is empty</h3>'+
      '<p>Let\'s fix that.</p>'+
      '<a href="/collections/all" class="mkh-drw-btn mkh-drw-btn-primary" onclick="closeDrawer()">Shop bestsellers</a>'+
      '</div>';
    foot.style.display='none';
    return;
  }
  var html='';
  var savings=0;
  cart.items.forEach(function(item){
    var orig=item.original_line_price;
    var line=item.line_price;
    if(orig>line)savings+=orig-line;
    var imgUrl=item.featured_image&&item.featured_image.url?item.featured_image.url:item.image;
    html+='<div class="mkh-line-item">'+
      '<a href="'+item.url+'" class="mkh-li-img">'+
      (imgUrl?'<img src="'+imgUrl+'" alt="'+item.product_title+'" loading="lazy">':'')+
      '</a>'+
      '<div class="mkh-li-main">'+
      '<a href="'+item.url+'" class="mkh-li-name">'+item.product_title+'</a>'+
      '<div class="mkh-li-prices">'+
      '<span class="mkh-li-price">'+fmt(item.price)+'</span>'+
      (item.original_price>item.price?'<span class="mkh-li-was">'+fmt(item.original_price)+'</span>':'')+
      '</div>'+
      '<div class="mkh-li-foot">'+
      '<div class="mkh-qty-mini">'+
      '<button data-drw-action="qty" data-key="'+item.key+'" data-qty="'+(item.quantity-1)+'" aria-label="Decrease">&minus;</button>'+
      '<span>'+item.quantity+'</span>'+
      '<button data-drw-action="qty" data-key="'+item.key+'" data-qty="'+(item.quantity+1)+'" aria-label="Increase">+</button>'+
      '</div>'+
      '<button class="mkh-li-remove" data-drw-action="remove" data-key="'+item.key+'">Remove</button>'+
      '</div>'+
      '</div>'+
      '</div>';
  });
  body.innerHTML=html;
  // Footer
  var savingsEl=el('mkh-drawer-savings');
  if(savings>0){savingsEl.style.display='flex';el('mkh-savings-amt').textContent='-'+fmt(savings);}else{savingsEl.style.display='none';}
  el('mkh-drawer-subtotal').textContent=fmt(cart.total_price);
  foot.style.display='';
  // Update cart badges
  document.querySelectorAll('[data-cart-count],.site-header__cart-count,.cart-link__bubble-num').forEach(function(b){
    b.textContent=cart.item_count;
    b.style.display=cart.item_count>0?'':'none';
  });
}

function changeQty(key,qty){
  el('mkh-drawer-body').style.opacity='.5';
  fetch('/cart/change.js',{
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({id:key,quantity:qty})
  }).then(function(r){return r.json();})
    .then(function(c){el('mkh-drawer-body').style.opacity='';renderDrawer(c);})
    .catch(function(){el('mkh-drawer-body').style.opacity='';});
}

// Event delegation
document.addEventListener('click',function(e){
  // Qty/remove in drawer
  var drwBtn=e.target.closest('[data-drw-action]');
  if(drwBtn){
    var action=drwBtn.dataset.drwAction;
    var key=drwBtn.dataset.key;
    if(action==='qty'){changeQty(key,parseInt(drwBtn.dataset.qty,10)||0);}
    else if(action==='remove'){changeQty(key,0);}
    return;
  }
  // Close
  if(e.target.id==='mkh-drawer-overlay'||e.target.id==='mkh-drawer-close'||e.target.closest('#mkh-drawer-close')){
    closeDrawer();return;
  }
  // Cart icon — intercept any /cart link NOT in drawer foot or cart page
  var cartLink=e.target.closest('a[href="/cart"]');
  if(cartLink&&!cartLink.closest('.mkh-drawer-foot')&&!document.body.classList.contains('template-cart')){
    e.preventDefault();openDrawer();return;
  }
  // ATC buttons that bypass native form -> open drawer after add
  var atcBtn=e.target.closest('.mkh-product-card__atc[data-variant-id]');
  if(atcBtn&&!atcBtn.dataset.drawerBound){
    // handled by existing mkitchen-enhancements.js; after add, open drawer
    setTimeout(function(){
      if(window._mkhLastAtcSuccess){window._mkhLastAtcSuccess=false;}
    },500);
  }
});
// Escape key
document.addEventListener('keydown',function(e){if(e.key==='Escape')closeDrawer();});

// Patch mkhCardATC to open drawer after add
document.addEventListener('mkh:cart-updated',function(){loadCart();});

// Init badge count on page load
fetch('/cart.js',{headers:{'Accept':'application/json'}})
  .then(function(r){return r.json();})
  .then(function(c){
    document.querySelectorAll('[data-cart-count],.site-header__cart-count,.cart-link__bubble-num').forEach(function(b){
      b.textContent=c.item_count;
      b.style.display=c.item_count>0?'':'none';
    });
  });

})();
